export enum ViewMode {
  Create = 'create',
  View = 'view',
  Edit = 'edit',
}
